<template>
  <div class="fotersa">
    <div class="head-input">
      <a-form :layout="formLayout">
        <a-row :gutter="24" type="flex" justify="start">
          <a-col :span="6" class="fl fw">
            <a-form-item
              label="权益名称"
              :label-col="formItemLayout.labelCol"
              :wrapper-col="formItemLayout.wrapperCol"
            >
              <a-input
                placeholder="请输入"
                v-model="equityName"
                :allowClear="true"
              />
            </a-form-item>
          </a-col>
          <a-col :span="6" class="fl2 fh">
            <a-form-item
              label="会员权益状态"
              :label-col="formItemLayout.labelCol"
              :wrapper-col="formItemLayout.wrapperCol"
            >
              <a-select
                style="width: 160px"
                :allowClear="true"
                v-model="memberStatus"
                placeholder="请选择"
              >
                <a-select-option
                  v-for="item in dictStatus"
                  :key="item.value"
                  :value="item.value"
                >
                  {{ item.label }}
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :span="4" class="oper">
            <div style="height: 41px; line-height: 41px">
              <a-button
                class="btone"
                style="margin-left: -4px"
                @click="searchList(1)"
                >查询</a-button
              >
              <a-button class="bttwo" @click="addMemberFn()">新增</a-button>
            </div>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <!-- 展示内容 -->
    <div class="base-content">
      <!-- 表格 -->
      <a-table
        :columns="columns"
        :rowKey="
          (record, index) => {
            return index;
            tableData;
          }
        "
        :data-source="tableData"
        :pagination="false"
        bordered
        size="small"
        :scroll="{ x: 1000, y: 'calc(100vh - 300px)' }"
      >
        <div slot="index" slot-scope="text, record, index">
          {{ index + (pageNum - 1) * pageSize + 1 }}
        </div>
        <span slot="memberStatus" slot-scope="text, record">
          <span v-if="record.memberStatus == 1"><a-badge color="cyan" /></span>
          <span v-else-if="record.memberStatus == 2"><a-badge color="red" /></span>
          {{ record.memberStatus | DictionaryFilter("MEM_STATUS") }}
        </span>
        <span slot="useRebate" slot-scope="text, record">
          {{ record.useRebate | DictionaryFilter("MEM_DISCOUNT") }}
        </span>
        <div slot="operation" slot-scope="text">
          <a-dropdown>
            <a-menu
              slot="overlay"
              style="text-align: center"
            >
              <a-menu-item key="1">
                <a
                  href="javascript:;"
                  class="modification"
                  @click="updateMemberFn(text)"
                  >编辑</a
                ></a-menu-item
              >
              <a-menu-item key="2">
                <a
                  href="javascript:;"
                  class="modification"
                  @click="handleDelete(text)"
                  >删除</a
                >
              </a-menu-item>
            </a-menu>
            <a-button style="margin-left: 8px" class="btaction">
              更多操作 <a-icon type="down" />
            </a-button>
          </a-dropdown>
        </div>
      </a-table>

      <!-- 分页 -->
      <div class="base-pagination">
        <div class="total-view">
          共{{ totalRows }}条数据，第{{ pageNum }}/{{ totalPages }}页
        </div>
        <div class="pagination-buttons">
          <a-pagination
            v-model="pageNum"
            :total="totalRows"
            :defaultPageSize="pageSize"
            show-less-items
            @change="changePageFn($event)"
          />
        </div>
      </div>
      <!-- 确定新增 + 编辑 -->
      <a-modal
        v-model="visible"
        width="1000px"
        :destroyOnClose="true"
        :maskClosable="false"
        v-if="visible"
        :closable="false"
      >
      <div slot="title" class="tip-icon"> {{Title}} </div>
        <template slot="footer" slot-scope="text">
          <a-button
            style="margin-right: 15px;"
            key="submit"
            class="btaction"
            :loading="addMembConfLoading"
            @click="addMemberbenefits"
            :disabled="disabled"
          >
            确认
          </a-button>
          <a-button
            class="btaction"
            @click="handleCancel(text)"
            :disabled="disabled"
          >
            取消
          </a-button>
        </template>
        <div class="add-mess">
          <a-form-model
            ref="ruleForm"
            :model="form"
            :rules="rules"
            class="input-input"
            :label-col="labelCol"
            :wrapper-col="wrapperCol"
          >
            <a-row>
              <a-col :span="12">
                <a-form-model-item
                  ref="equityName"
                  label="权益名称"
                  prop="equityName"
                >
                  <a-input
                    :disabled="disabled"
                    v-model="form.equityName"
                    placeholder="请输入权益名称"
                  />
                </a-form-model-item>
              </a-col>

              <a-col :span="12">
                <a-form-model-item
                  ref="faceValue"
                  label="面值"
                  prop="faceValue"
                >
                  <a-input
                    style="width: 317px"
                    type="number"
                    suffix="元"
                    :disabled="disabled"
                    v-model="form.faceValue"
                    placeholder="请输入面值"
                  />
                </a-form-model-item>
              </a-col>
            </a-row>
            <a-row>
              <a-col :span="12">
                <a-form-model-item ref="vipId" label="VIP等级" prop="vipId">
                  <a-select
                    show-search
                    v-model="form.vipId"
                    placeholder="请选择等级"
                  >
                    <a-select-option
                      v-for="item in vipStatus"
                      :key="item.id"
                      :value="item.id"
                      >{{ item.gradeName }}</a-select-option
                    >
                  </a-select>
                </a-form-model-item>
              </a-col>

              <a-col :span="12">
                <a-form-model-item
                  ref="memberStatus"
                  label="会员权益状态"
                  prop="memberStatus"
                >
                  <a-select
                    show-search
                    v-model="form.memberStatus"
                    placeholder="请选择状态"
                  >
                    <a-select-option
                      v-for="item in dictStatus"
                      :key="item.value"
                      :value="item.value"
                      >{{ item.label }}</a-select-option
                    >
                  </a-select>
                </a-form-model-item>
              </a-col>
            </a-row>
            <a-row>
              <a-col :span="24">
                <a-form-model-item
                  ref="remark"
                  label="说明"
                  prop="remark"
                  :label-col="{ span: 3 }"
                  :wrapper-col="{ span: 20 }"
                >
                  <a-input
                    :disabled="disabled"
                    v-model="form.remark"
                    placeholder="套餐说明"
                    type="textarea"
                    style="height: 80px"
                  />
                </a-form-model-item>
              </a-col>
            </a-row>
            <a-row>
              <a-col :span="24">
                <a-form-model-item prop="imgSts" label="配图">
                  <upload :downid="uplodImgId" uploadNum="1" :uploadAgain="uploadAgain" :fileNum="fileNum" @listen ="listen"></upload>
                </a-form-model-item>
              </a-col>
            </a-row>
          </a-form-model>
        </div>

        <!-- 可编辑弹框表格 -->
        <a-button class="bttwo" @click="addItem()">新增</a-button>
        <a-table
          :columns="columns1"
          :data-source="data1"
          bordered
          style="margin-top: 10px"
          :pagination="false"
        >
          <span slot="index" slot-scope="text, record, index">
            {{ index + 1 }}
          </span>
          <span slot="equGoodName" slot-scope="text, record">
            {{ record.equGoodName }}
          </span>
          <template
            v-for="col in [
              'equId',
              'category',
              'count',
              'equCategory',
              'remark',
              'operation',
            ]"
            :slot="col"
            slot-scope="text, record"
          >
            <div :key="col">

              <a-select
                placeholder="请输选择"
                v-if="col == 'category'"
                v-model="record.category"
                style="width: 120px"
              >
                <a-select-option
                  v-for="item in vipcommodity"
                  :key="item.value"
                  :value="item.value"
                  >{{ item.label }}</a-select-option
                >
              </a-select>

              <a-select
                placeholder="请选择"
                v-if="col == 'equCategory'"
                v-model="record.equCategory"
                style="width: 120px"
              >
                <a-select-option
                  v-for="item in commodity"
                  :key="item.value"
                  :value="item.value"
                  >{{ item.label }}</a-select-option
                >
              </a-select>

              <div v-if="record.equCategory == '2'">
                <a-input
                :disabled="record.equCategory == '2'"
                v-if="col == 'count'"
                style="margin: -5px 0"
                />
              </div>
              <div v-else>
                <a-input
                type="number"
                placeholder="请输入"
                v-if="col == 'count'"
                style="margin: -5px 0"
                v-model="record.count"
                :value="text"
                />
              </div>
            </div>
          </template>
          <template slot="operation" slot-scope="text, record">
            <div class="editable-row-operations">
              <span>
                <a-button class="bttwo" @click="() => deleteItem(text, record)"
                  >删除</a-button
                >
              </span>
            </div>
          </template>
        </a-table>

        <!-- 新增商品名称 -->
        <a-modal
          v-model="visible2"
          class="modal"
          width="800px"
          :maskClosable="false"
          @cancel="closeGood(false)"
        >
        <div slot="title" class="tip-icon"> {{title2}} </div>
          <!-- 展示内容 -->
          <div class="base-content">
            <!-- 表格 -->
            <a-table
              :columns="columns2"
              :rowKey="record=>record.id"
              :data-source="tableData2"
              :pagination="false"
              bordered
              size="small"
              :row-selection="{
                selectedRowKeys: selectedRowKeys,
                onChange: onSelectChange,
              }"
              :scroll="{ x: 700, y: 'calc(100vh - 300px)' }"
              class="table"
            >
              <span slot="index1" slot-scope="text, record, index">
                {{ index + (pageNum1 - 1) * pageSize1 + 1 }}
              </span>
              <span slot="expiryDate" slot-scope="text, record">
                {{ record.expiryDate | DictionaryFilter("GOOD_VALIDITY") }}
              </span>
            </a-table>

            <!-- 分页 -->
            <div class="base-pagination">
              <div class="total-view">
                共{{ totalRows1 }}条数据，第{{ pageNum1 }}/{{ totalPages1 }}页
              </div>
              <div class="pagination-buttons">
                <a-pagination
                  v-model="pageNum1"
                  :total="totalRows1"
                  :defaultPageSize="pageSize1"
                  show-less-items
                  @change="changePage($event)"
                />
              </div>
            </div>
          </div>
          <template #footer>
            <!-- 底部按钮区域 -->
            <a-button class="btaction" @click="addEquityGoodFn"
              >确 定</a-button
            >
          </template>
        </a-modal>
      </a-modal>
    </div>
  </div>
</template>
<script>
import {
  memberQuery,
  Addmember,
  memberUpdate,
  goodList,
  memberDel,
  meId,
  getId,
  queryBySerStatus
} from "@/api/api.js";
import upload from "@/components/upload/upload.vue";
import { DictionaryService } from "@common/services/dictionary.service";
import moment from "moment";
moment.locale("zh-cn");

export default {
  components: { upload },
  data() {
    var checkAge = (rule, value, callback) => {
      let reg =
        /(^[1-9]([0-9]+)?(\.[0-9]{1,2})?$)|(^(0){1}$)|(^[0-9]\.[0-9]([0-9])?$)/;
      if (!value) {
          return callback(new Error("请输入面值"));
      }  else if (Number(value) <= 0) {
        return callback(new Error('请输入大于0的数'));
      } else if (String(parseInt(value)).length > 8) {
        return callback(new Error("请输入整数位不超过8个字符"));
      } else if (!reg.test(value)) {
        return  callback(new Error("小数点后最多只能输入两位"));
      } else {
        return  callback();
      }
    };
    var checkAge1 = (rule, value, callback) => {
      if (value) {
        if (!Number.isInteger(Number(value))) {
          return callback(new Error('请输入整数'));
        } else if(value < 0){
          return callback(new Error('请输入大于等于0的数'));
        } else {
          return callback();
        }
      } else {
        return callback();
      }
    };
    return {
      selectedRowKeys: [],
      selectedRows: [],
      labelCol: { span: 6 },
      wrapperCol: { span: 16 },
      equityName: "",
      memberStatus: undefined,

      //表格
      tableData: [],
      Title: "",
      //新增弹出框
      visible: false,
      visible2: false,
      title2: "",
      tableData2: [],
      id: "",
      uplodImgId: "",
      uploadAgain:false,//是否再次上传
      fileNum:0,        //上传文件个数
      // 表单验证
      rules: {
        equityName: [
          {
            required: true,
            message: "请输入权益名称",
            trigger: "blur",
          },
          {
            min: 1,
            max: 50,
            message: "长度在 1 到 50 个字符",
            trigger: "blur",
          },
        ],
        faceValue: [
          {
            required: true,
            validator: checkAge,
            trigger: "change",
          },
        ],
        vipId: [
          {
            required: true,
            message: "请选择VIP等级",
            trigger: "blur",
          }
        ],
        remark: [
          {
            max: 100,
            message: "说明长度不能超过100",
          },
        ],
        memberStatus: [
          {
            required: true,
            message: "请选择状态",
            trigger: "change",
          },
        ],
        imgSts: [{
          required: true,
          message: "请上传充值凭证",
        }]
      },
      form: {
        equityName: "",
        faceValue: "",
        vipId: undefined,
        memberStatus: undefined,
        imgSts: '1',
        remark:"",
      },
      rules2: {
        category: [
          {
            required: true,
            message: "请选择状态",
            trigger: "change",
          },
        ],
        equCategory: [
          {
            required: true,
            message: "请选择状态",
            trigger: "change",
          },
        ],
        count: [
          {
            required: true,
            message: "请输入",
            trigger: "blur",
          },
          {
            validator: checkAge1,
            trigger: "change",
          },
        ],
      },

      //组件列表是否存在
      imgSts: "",
      //新增会员确认加载
      addMembConfLoading: false,
      disabled: false,
      //数列
      columns: [
        {
          title: "序号",
          align: "center",
          dataIndex: "index",
          width: 40,
          key: "index",
          ellipsis: true,
          scopedSlots: { customRender: "index" },
        },
        {
          title: "权益名称",
          dataIndex: "equityName",
          key: "equityName",
          align: "center",
          ellipsis: true,
          width: 100,
          scopedSlots: { customRender: "equityName" },
        },

        {
          title: "面值(元)",
          dataIndex: "faceValue",
          key: "faceValue",
          align: "center",
          ellipsis: true,
          width: 150,
          scopedSlots: { customRender: "faceValue" },
        },
        {
          title: "消费折扣",
          dataIndex: "useRebate",
          key: "useRebate",
          align: "center",
          ellipsis: true,
          width: 100,
          scopedSlots: { customRender: "useRebate" },
        },
        {
          title: "VIP等级",
          dataIndex: "gradeName",
          key: "gradeName",
          align: "center",
          ellipsis: true,
          width: 100,
          scopedSlots: { customRender: "gradeName" },
        },
        {
          title: "说明",
          dataIndex: "remark",
          key: "remark",
          align: "center",
          ellipsis: true,
          width: 150,
          scopedSlots: { customRender: "remark" },
        },

        {
          title: "会员权益状态",
          dataIndex: "memberStatus",
          key: "memberStatus",
          align: "center",
          ellipsis: true,
          width: 100,
          scopedSlots: { customRender: "memberStatus" },
        },
        {
          title: "操作",
          key: "operation",
          align: "center",
          width: 100,
          scopedSlots: {
            customRender: "operation",
          },
        },
      ],
      //数列1
      columns1: [
        {
          title: "序号",
          align: "center",
          dataIndex: "index1",
          width: 60,
          key: "index1",
          ellipsis: true,
          scopedSlots: { customRender: "index" },
        },
        {
          title: "权益商品名称",
          dataIndex: "equGoodName",
          key: "equGoodName",
          align: "center",
          ellipsis: true,
          width: 150,
          scopedSlots: { customRender: "equGoodName" },
        },
        {
          title: "类别",
          dataIndex: "category",
          key: "category",
          align: "center",
          ellipsis: true,
          width: 150,
          scopedSlots: { customRender: "category" },
        },
        {
          title: "权益类别",
          dataIndex: "equCategory",
          key: "equCategory",
          align: "center",
          ellipsis: true,
          width: 150,
          scopedSlots: { customRender: "equCategory" },
        },

        {
          title: "数量",
          dataIndex: "count",
          key: "count",
          align: "center",
          ellipsis: true,
          width: 100,
          scopedSlots: { customRender: "count" },
        },
        {
          title: "操作",
          key: "operation",
          align: "center",
          width: 100,
          scopedSlots: {
            customRender: "operation",
          },
        },
      ],
      //数列2
      columns2: [
        {
          title: "权益商品编号",
          dataIndex: "goodCode",
          key: "goodCode",
          align: "center",
          ellipsis: true,
          width: 150,
          scopedSlots: { customRender: "goodCode" },
        },

        {
          title: "权益商品名称",
          dataIndex: "goodName",
          key: "goodName",
          align: "center",
          ellipsis: true,
          width: 150,
          scopedSlots: { customRender: "goodName" },
        },

        {
          title: "权益商品单价",
          dataIndex: "goodPrice",
          key: "goodPrice",
          align: "center",
          ellipsis: true,
          width: 100,
          scopedSlots: { customRender: "goodPrice" },
        },
        {
          title: "有效期",
          dataIndex: "expiryDate",
          key: "expiryDate",
          align: "center",
          ellipsis: true,
          width: 100,
          scopedSlots: { customRender: "expiryDate" },
        },
      ],
      pageNum: 1,
      pageSize: 10,
      totalRows: 0,
      totalPages: 0,

      pageNum1: 1,
      pageSize1: 10,
      totalRows1: 0,
      totalPages1: 0,

      dictStatus: [],
      formLayout: "horizontal",
      url: "",
      list: [],
      data1: [],
      vipStatus: [],
      commodity: [],
      vipcommodity: [],
      goodValidity: [],
    };
  },

  activated() {
    DictionaryService.getAllNeedDic([
      "MEM_STATUS",
      "MEM_DISCOUNT",
      "GRANT_TYPE",
      "MEM_PG_CLASS",
      "GOOD_VALIDITY",
    ]).then((res) => {
      this.dictStatus = DictionaryService.getOptions("MEM_STATUS");
      this.commodity = DictionaryService.getOptions("GRANT_TYPE");
      this.vipcommodity = DictionaryService.getOptions("MEM_PG_CLASS");
      this.goodValidity = DictionaryService.getOptions("GOOD_VALIDITY");
      this.searchList();
      this.querygoodList();
    });
  },
  computed: {
    formItemLayout() {
      const { formLayout } = this;
      return formLayout === "horizontal"
        ? {
            labelCol: { span: 6 },
            wrapperCol: { span: 18 },
          }
        : {};
    },
    buttonItemLayout() {
      const { formLayout } = this;
      return formLayout === "horizontal"
        ? {
            wrapperCol: { span: 6, offset: 18 },
          }
        : {};
    },
  },
  methods: {
    //查询启用的VIP等级
    queryBySerStatus() {
      queryBySerStatus().then((res) => {
        this.vipStatus = res.content;
      });
    },
    //监听上传文件
    listen(val) {
     this.uploadAgain = false;
      if(val.length == 0){
        this.imgSts = false;
      } else {
        this.imgSts = true;
        this.uploadAgain = true;//监听是否已上传文件
      }
      this.fileNum = val.length;
    },
    //分页
    changePageFn(event) {
      this.pageNum = event;
      this.searchList();
    },
    changePage(event) {
      this.pageNum1 = event;
      this.querygoodList();
    },
    //列表查询
    searchList(sum = 2) {
      if (sum == 1) this.pageNum = 1;
      let obj = {
        pageParam: {
          pageNum: this.pageNum,
          pageSize: this.pageSize,
          orderBy: "",
        },
        content: {
          equityName: this.equityName,
          memberStatus: this.memberStatus,
        },
      };
      memberQuery(obj).then(
        (res) => {
          this.tableData = res.content.rows;
          this.totalRows = res.content.page.totalRows;
          this.totalPages = Math.ceil(this.totalRows / this.pageSize);
        },
        (err) => {}
      );
    },
    // 关闭箭头的回调
    handleCancel(e) {
      if (!this.imgSts && this.Title == "会员权益修改") { 
        this.$message.error("请配置图片");
      } else {
        this.visible = false;
        this.id = "";
        this.$refs["ruleForm"].resetFields();
        this.form.remark = "";
        this.data1 = [];
        this.selectedRows = [];
      }
    },
    //关闭权益商品弹框
    closeGood(){
      this.selectedRowKeys = [];//清空选中行
      //页面重置第一页
      this.changePage(1);
    },
    //新增弹窗
    addMemberFn() {
      //获取ID
      let pageParam = {
        pageNum: 0,
        pageSize: 0,
        orderBy: "",
      };
      getId({ pageParam: pageParam }).then((res) => {
        this.uplodImgId = res.content.id;
        this.disabled = false;
        this.visible = true;
        this.Title = "会员权益新增";
        this.searchList();
        //vip等级
        this.queryBySerStatus();
        //新增选中框赋值为空
        this.selectedRows = [];
      },(err) => {
        this.$message.error("获取id失败");
      }
      )
    },
    //修改会员权益
    updateMemberFn(key, type) {
      this.Title = "会员权益修改";
      this.disabled = false;
      this.queryBySerStatus();
      this.visible = true;
      meId({ id: key.id }).then((res) => {
        this.form.id = res.content.id;
        this.form.vipId = res.content.vipId;
        this.form.equityName = res.content.equityName;
        this.form.faceValue = res.content.faceValue;
        this.form.memberStatus = res.content.memberStatus;
        this.form.remark = res.content.remark;
        this.data1 = res.content.equityGoodDetailList;
        this.equGoodName = res.content.equityGoodDetailList.equGoodName;
        this.uplodImgId = res.content.id;
      });
    },
    // 确定新增 + 编辑
    addMemberbenefits(e) {
      if (this.imgSts) {
      this.addMembConfLoading = true;
      let equityGoodDetailList = [];
      let list = {};
      this.data1.forEach((item) => {
        if (item.equCategory == '2') {
          item.count = undefined;
        }
        list = {
          category: item.category,
          count: item.count,
          equCategory: item.equCategory,
          equId: item.equId,
          equGoodName: item.equGoodName,
        };
        equityGoodDetailList.push(list);
      });
      let isAll = equityGoodDetailList.some((item) => {
        if (item.category == undefined || item.equCategory == undefined) {
          return true;
        }
        if (item.equCategory == "1" && item.count == undefined) {
          return true;
        }
      });
      if (isAll) {
        this.$message.error("请补全权益商品信息");
        this.addMembConfLoading = false;
        return;
      }
      let isCount = equityGoodDetailList.some((item) => {
        if(item.count != undefined){
          if (Number(item.count) <= 0) {
            return true;
          } else if (!Number.isInteger(Number(item.count))) {
            return true;
          }
        }
      });
      if (isCount) {
        this.$message.error("请输入权益商品数量为整数并且大于0");
        this.addMembConfLoading = false;
        return;
      }
      if (equityGoodDetailList.length <= 0) {
          this.$message.error("请选择权益商品");
          this.addMembConfLoading = false;
          return;
      }
      // 判断是新增还是编辑
        if (this.Title == "会员权益修改") {
          if (this.data1.length<=0) {
            this.$message.error("请选择权益商品");
            this.addMembConfLoading = false;
            return;
          }
        this.$refs.ruleForm.validate((valid) => {
          if (valid) {
            memberUpdate({
              id: this.form.id,
              vipId: this.form.vipId,
              equityName: this.form.equityName,
              faceValue: this.form.faceValue,
              memberStatus: this.form.memberStatus,
              remark: this.form.remark,
              equityGoodDetailList: equityGoodDetailList,
            }).then(
              (res) => {
                this.$nextTick(() => {
                  this.$refs["ruleForm"].resetFields();
                });

                this.visible = false;
                this.addMembConfLoading = false;
                this.searchList();
                this.$message.success("修改成功");
                this.data1 = [];
                this.selectedRows = [];
                this.uplodImgId = '';
              },
              (err) => {
                this.addMembConfLoading = false;
              }
            );
          } else {
            this.addMembConfLoading = false;
            return false;
          }
        });
        } else if (this.Title == "会员权益新增") {
          // 校验表单
          this.$refs.ruleForm.validate((valid) => {
            if (valid) {
              Addmember({
                vipId: this.form.vipId,
                equityName: this.form.equityName,
                faceValue: this.form.faceValue,
                memberStatus: this.form.memberStatus,
                remark: this.form.remark,
                equityGoodDetailList: equityGoodDetailList,
                id:this.uplodImgId,
              }).then(
                (res) => {
                  this.uplodImgId = '';
                  this.addMembConfLoading = false;
                  this.visible = false;
                  this.searchList();
                  this.$message.success("添加成功");
                  this.data1 = [];
                  this.selectedRows = [];
                  this.$refs["ruleForm"].resetFields();
                },
                (err) => {
                  this.addMembConfLoading = false;
                }
              );
            } else {
              this.addMembConfLoading = false;
              return false;
            }
          });
        }
      } else {
        this.$message.error("请配置图片");
      }
    },

    //删除
    handleDelete(text) {
      this.$confirm({
        title: "确定是否删除?",
        okText: "是",
        cancelText: "否",
        onOk: () => {
          memberDel({ id: text.id }).then(
            (res) => {
              this.$message.success("删除成功");
              this.searchList();
            },
            (err) => {}
          );
        },
        onCancel: () => {},
      });
    },
    //弹框选择权益商品名称
    addItem(key) {
      this.visible2 = true;
      this.title2 = "选择权益商品名称";
      this.querygoodList();
    },
    //查询商品名称
    querygoodList(sum = 2) {
      if (sum == 1) this.pageNum1 = 1;
      let obj = {
        pageParam: {
          pageNum: this.pageNum1,
          pageSize: this.pageSize1,
          orderBy: "",
        },
        content: {
          goodCode: this.goodCode,
          goodName: this.goodName,
        },
      };
      goodList(obj).then(
        (res) => {
          this.tableData2 = res.content.rows;

          this.totalRows1 = res.content.page.totalRows;
          this.totalPages1 = Math.ceil(this.totalRows1 / this.pageSize1);
        },
        (err) => {}
      );
    },
    /* 单选框 */
    onSelectChange(selectedRowKeys, selectedRows) {
      this.selectedRows = this.selectedRows.concat(selectedRows);

      //去重
      var result = [];
      var obj = {};
      for (var i = 0; i < this.selectedRows.length; i++) {
        if (!obj[this.selectedRows[i].id]) {
          result.push(this.selectedRows[i]);
          obj[this.selectedRows[i].id] = true;
        }
      }
      this.selectedRows = result;

      this.selectedRowKeys = selectedRowKeys;

      this.selectedRows.forEach((item) => {
        this.goodNameee = item.goodName;
        this.id = item.id;
      });
    },
    //新增商品名称确定
    addEquityGoodFn() {
      //根据key值选取选中商品
      let selectedRowsMed = this.selectedRows;
      this.selectedRows = [],
        this.selectedRowKeys.forEach((item) => {
          selectedRowsMed.forEach((itmeRows) => {
            if (item === itmeRows.id) {
              this.selectedRows.push(itmeRows)
            }
          })
        });

      this.visible2 = false;
      this.selectedRowKeys = [];
      this.data1 = this.data1.concat(this.selectedRows);

      //统一名称
      this.data1.forEach((item) => {
        item.equGoodName = item.goodName || item.equGoodName;
        item.equId = item.id || item.equId;
      });

      //去重
      var result = [];
        var obj = {};
        for (var i = 0; i < this.data1.length; i++) {
          if (!obj[this.data1[i].equId]) {
            result.push(this.data1[i]);
            obj[this.data1[i].equId] = true;
          }
        }
      this.data1 = result;

      //重置新增商品页面为第一页
      this.changePage(1);
    },

    //删除权益商品信息
    deleteItem(key) {
      //删除复选框中的值
      if(this.selectedRows.length != 0){
        for (let i = 0; i<this.selectedRows.length; i++){
          if (this.selectedRows[i].equId == key.equId){
            this.selectedRows.splice(i, 1);
          }
        }
      }
      if (this.data1.length === 0) {
        return;
      }
      //删除修改复选数据
      for (let i = 0; i<this.data1.length; i++){
        if (this.data1[i].equId == key.equId){
          this.data1.splice(i, 1);
        }
      }
    },
  },
};
</script>
<style lang="less" scoped="scoped">
/deep/ .ant-modal-body {
  max-height: 450px;
  overflow-y: auto;
}
.bbbbtttt {
  color: rgba(0, 0, 0, 0.25);
  background-color: #f5f5f5;
  border-color: #d9d9d9;
  text-shadow: none;
  box-shadow: none;
}
.base-pagination {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
/deep/.ant-table-body {
  margin-top: -8px !important;
}
.sp_name {
  display: inline-block;
  font-size: 20px;
  margin: 0 0 20px 10px;
}
.fotersa {
  width: 100%;
  height: 100%;
  .title-name {
    width: 100%;
    height: 46px;
    overflow: hidden;
    .sp_name {
      display: inline-block;
      font-size: 20px;
      margin: 0 0 20px 10px;
    }
  }
  .flex {
    display: flex;
    align-items: center;
  }
  .flex label {
    font-size: 16px;
    width: 73px;
  }
  .btone {
    margin-right: 20px;
  }
  /deep/.ant-table-thead {
    background-color: #dcf4ff;
  }

  a {
    margin-left: 10px;
  }
  a:hover {
    color: #70b9cf;
  }
}
/deep/.ant-form-item {
  margin-bottom: 0;
}
.title-name::before {
  content: "";
  width: 5px;
  height: 20px;
  display: inline-block;
  overflow: hidden;
  background-color: #0b2464;
}
/deep/ .ant-table-body {
  max-height: 487px;
  margin: 0 !important;
}
/deep/.ant-table-tbody > tr > td {
  padding: 11px 16px;
}
.add-mess {
  width: 100%;
  height: 100%;

  /deep/ .ant-form-item {
    margin-bottom: 20px !important;
  }
  /deep/ .ant-form-item-label {
    width: 110px;
  }
}
/deep/ .form .ant-input,
.ant-form-item-control,
.ant-form-item-control-wrapper {
  width: 160px;
}
.fw {
  width: 250px;
}
.fh {
  width: 275px;
}
.oper {
  width: 200px;
}
/deep/ .fl .ant-row .ant-col-6:nth-child(1) {
  width: 76px;
}
/deep/ .fl1 .ant-row .ant-col-6:nth-child(1) {
  width: 70px;
}
/deep/ .fl2 .ant-row .ant-col-6:nth-child(1) {
  width: 97px;
}
/deep/ .ant-input-affix-wrapper {
  width: 160px;
}
/deep/ .ant-col-18 {
  width: 50%;
}

.imgBox /deep/ .ant-modal-close-x {
  width: 27px !important;
  line-height: 27px !important;
}
.peitu {
  margin-left: 63px;
}
.editable-row-operations a {
  margin-right: 8px;
}
</style>